import AutomaticModerationModel from "./AutomaticModerationModel";

export default class DiscussionsConfigModel {
  public enabled: boolean = false;
  public clientId: string = null;
  public automaticModeration: AutomaticModerationModel =
    new AutomaticModerationModel();
}
